import type { QueryParamConfig } from 'use-query-params';

import type { GridSortItem, GridSortModel } from '@packages/fenrir/components';

export const DataGridProSortParam: QueryParamConfig<GridSortModel | undefined> =
  {
    encode: (sort) => {
      if (!sort) {
        return null;
      }

      return sort
        .map(({ field, sort }) => `${sort === 'desc' ? '-' : ''}${field}`)
        .join(',');
    },

    decode: (sort) => {
      const hasNoSortApplied = sort === '';
      if (hasNoSortApplied) {
        return [];
      }

      const hasDefaultSortApplied = !sort;
      if (hasDefaultSortApplied) {
        return undefined;
      }

      const multiSortParams = Array.isArray(sort) ? sort : [sort];

      const gridSortItems: GridSortItem[] = multiSortParams
        .filter<string>((sortParam): sortParam is string => !!sortParam)
        .flatMap((sortParam) =>
          sortParam.split(',').map((sortParam) => {
            const isDesc = sortParam.at(0) === '-';

            const field = isDesc ? sortParam.substring(1) : sortParam;
            const sort = isDesc ? 'desc' : 'asc';

            return { field, sort };
          }),
        );

      return gridSortItems;
    },
  };
